import { render, staticRenderFns } from "./attributeConfig.vue?vue&type=template&id=9fe4f638&scoped=true"
import script from "./attributeConfig.vue?vue&type=script&lang=js"
export * from "./attributeConfig.vue?vue&type=script&lang=js"
import style0 from "./attributeConfig.vue?vue&type=style&index=0&id=9fe4f638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe4f638",
  null
  
)

export default component.exports